const TRANSLATIONS_EN = {
  'application.title': 'SAILOR File Injection Tool',
  'header.roles': 'Roles:',
  'header.log.out': 'Logout',

  'breadcrumb.home': 'Home',
  'breadcrumb.import': 'File-set ',
  'breadcrumb.file': 'File ',

  'button.save': 'Save',
  'button.cancel': 'Cancel',
  'button.ok': 'OK',
  'add_comment': 'Add comment',

  'upload.file': 'Upload',
  'upload.file.title': 'Upload new file-set',
  'upload.file.name': 'File name',
  'upload.file.type': 'File type',
  'upload.file.wait': 'Please wait a moment. Files are being uploaded, parsed and validated.',
  'upload.file.drag.and.drop': 'Drag & drop or click here to browse files',

  'upload.send': 'Send',
  'upload.accept': 'Accept all and distribute',
  'upload.reject': 'Refuse',
  'upload.reject.all': 'Refuse all',
  'upload.download': 'Download file-set',

  'upload.delete.modal.title': 'Delete confirmation',
  'upload.delete.modal.confirmation':
    'Are you sure you want to delete <strong>{{uploadName}}</strong> upload?',
  'upload.version': 'Upload version: ',

  'file.type.inspection.summary': 'Inspection summary',
  'file.type.action.summary': 'Observation summary',
  'file.type.report': 'Report',
  'file.type.unknown': 'Unknown',

  'report.details.object.details.title': 'Object details',
  'report.details.comments.title': 'Comments',
  'lifting.object.details.equipment': 'EQUIPMENT ID',
  'lifting.object.details.site': 'SITE',
  'lifting.object.details.impactFacility': 'IMPACT FACILITY',
  'lifting.object.details.description': 'DESCRIPTION',
  'lifting.object.details.buildingDescriptionEn': 'DESCRIPTION OF BUILDING',
  'lifting.object.details.responsible': 'RESPONSIBLE',
  'lifting.object.details.status': 'STATUS',
  'lifting.object.details.commissionDate': 'COMMISSION DATE',
  'lifting.object.details.inspector': 'INSPECTOR',
  'lifting.object.details.equipmentClass': 'CLASS',
  'lifting.object.details.manufacturer': 'MANUFACTURER',
  'lifting.object.details.hseCode': 'HSE CODE',
  'lifting.object.details.category': 'CATEGORY',
  'lifting.object.details.model': 'MODEL',
  'lifting.object.details.building': 'BUILDING',
  'lifting.object.details.serialNumber': 'SERIAL NUMBER',

  'electrical.object.details.buildingNumber': 'BUILDING',
  'electrical.object.details.department': 'DEPARTMENT',
  'electrical.object.details.experiment': 'EXPERIMENT',
  'electrical.object.details.site': 'SITE',

  'error.uploading.fileset': 'Error uploading file-set',
  'success.uploading.fileset': 'File-set was successfully uploaded',

  'upload.column.options': '',
  'uploadFilteredEntity_displayname': 'Uploads',
  'upload.column.name': 'Name',
  'upload.column.inspection.type': 'Import inspection type',
  'upload.column.version': 'Version',
  'upload.column.uploadDate': 'Upload date',
  'upload.column.company': 'Company',
  'upload.column.status': 'Status',
  'upload.column.uploadedBy': 'Uploaded by',
  'upload.column.isValid': 'Valid',
  'upload.column.isSent': 'Sent',
  'upload.column.isAccepted': 'Accepted',
  'upload.column.validationMessage': 'Validation message',

  'uploadFileFilteredEntity_displayname': 'File list',
  'upload.file.column.options': '',
  'upload.file.column.name': 'Name',
  'upload.file.column.type': 'Type',
  'upload.file.column.uploadDate': 'Upload date',
  'upload.file.column.equipmentCode': 'Equipment code',
  'upload.file.column.building': 'Building',
  'upload.file.column.interventionDate': 'Intervention date',
  'upload.file.column.executedBy': 'Executed by',
  'upload.file.column.company': 'Company',
  'upload.file.column.conclusion': 'Conclusion',
  'upload.file.column.valid': 'Valid',
  'upload.file.column.validationMessage': 'Validation message',
  'upload.file.column.status': 'Status',
  'upload.file.column.sailor.inspection': 'SAILOR link',
  'upload.file.column.actionCount': 'Total observations',
  'upload.file.column.refuse.options': 'Options',
  'upload_status.value.validated': 'Validated',
  'upload_status.value.missing_action_summary': 'Missing action summary', // TODO:is it useful this status?
  'upload_status.value.not_validated': 'Not validated',
  'upload_status.value.cancelled': 'Cancelled',
  'upload_status.value.waiting_for_acceptance': 'Waiting for acceptance',
  'upload_status.value.in_progress': 'In progress', // TODO:is it useful this status?
  'upload_status.value.refused': 'Refused',
  'upload_status.value.unknown': 'Unknown',
  'upload_status.value.accepted_and_distributed': 'Accepted and distributed',
  'upload.rejection.modal.title': 'Refusal reason',
  'upload.rejection.modal.placeholder':
    'Please, specify the reason why you are refusing this document',
  'upload.comment.count': '{{commentsCount}} comment(s) for this report.',

  'liftingActionSummaryFilteredEntity_displayname': 'List of Observations',
  'electricalActionSummaryFilteredEntity_displayname': 'List of Observations',
  'action.summary.column.options': '',
  'action.summary.column.equipmentCode': 'Equipment code',
  'action.summary.column.description': 'Description',
  'action.summary.column.building': 'Building',
  'action.summary.column.floor': 'Floor',
  'action.summary.column.local': 'Local',
  'action.summary.column.interventionDate': 'Intervention date',
  'action.summary.column.verificationReportNumber': 'Verification report number',
  'action.summary.column.conclusion': 'Conclusion',
  'action.summary.column.observationNumber': 'Observation number',
  'action.summary.column.observation': 'Observation',
  'action.summary.column.report': 'Report',
  'action.summary.column.valid': 'Valid',
  'action.summary.column.validationMessage': 'Validation message',
  'action.summary.column.isOutside': 'Is outside',
  'action.summary.column.equipment': 'Equipment',
  'action.summary.column.externalRegulatoryReference': 'External regulatory reference',
  'action.summary.column.cernRegulatoryReference': 'CERN regulatory reference',
  'action.summary.column.firstReportDate': 'First report date',
  'action.summary.column.criteria': 'Criteria',
  'action.summary.column.urgency': 'Priority',
  'action.summary.column.recommendation': 'Recommendation',
  'action.summary.column.assignee': 'Assignee',
  'action.summary.column.mitigation': 'Mitigation year',
  'action.summary.column.report.number': 'Report number',

  'lifting.inspection.summary.not.found':
    'Unable to correlate this observation with the Inspection summary record. The equipment {{equipmentCode}} is not found in the Inspection summary file',
  'lifting.verification.report.number.not.consistent':
    'Report name {{verificationNumber}} is not consistent for the verification report number',
  'lifting.building.do.not.match.inspection.summary':
    'Building {{building}} do not match building {{inspectionSummaryBuilding}} in the inspection summary',
  'lifting.building.not.found': 'Building {{building}} is not found in the database',
  'lifting.equipment.class.not.found':
    'Unable to obtain equipment class form InforEAM to determine observation theme',
  'lifting.equipment.not.found':
    'Equipment {{equipmentCode}} does not exist in the MTF/InforEAM database',
  'lifting.theme.not.found': "Theme {{theme}} is not conforming with SAILOR's catalog",
  'lifting.observation.number.sequence.error':
    'Observation number field should be {{nextSequenceNumber}}',
  'lifting.conclusion.not.found':
    "Action Summary Conclusion is not conforming with SAILOR's catalog",
  'lifting.conclusion.is.higher.than.inspection':
    'The priority of the conclusion of the inspection report must be equal to the highest priority among the observation conclusions',
  'lifting.inspection.conclusion.not.found':
    "Inspection Summary Conclusion is not conforming with SAILOR's catalog",

  'electrical.criteria.not.fond': "Criteria {{criteria}} is not conforming with SAILOR's catalog",
  'electrical.law.articles.are.empty':
    'At least one of the following fields should not be empty: {{fieldList}}',
  'electrical.inspection.summary.not.found':
    'Unable to correlate this observation with Inspection summary record. The building {{acronym}} is not found in the Inspection summary file',
  'electrical.executed.by.not.found':
    'The contractor who executed inspection {{executedBy}} does not exist in the database',
  'electrical.executed.by.ambiguous':
    "Contractor's name who executed inspection {{executedBy}} refers to multiple persons",
  'electrical.location.not.found':
    "Location {{locationName}} does not exist in CERN's official location database",
  'electrical.location.not.found.or.not.uploaded':
    "Verify if you uploaded PDF report for building {{locationName}}, otherwise it does not exist in CERN's official location database",
  'electrical.urgency.not.allowed': 'Urgency {{urgency}} is not allow. Value must be 1 or 2 or 3',
  'electrical.not.out.of.building':
    'Precise location (building, floor, room)  must be specified or outside the building should be as true',
  'electrical.no.report.for.acronym': 'Building {{acronym}} is not mentioned in any report',
  'electrical.assignee.not.found': 'Assignee {{assignee}} does not exist in the database',
  'electrical.assignee.ambiguous': 'Ambiguous assignee name: {{assignee}} refers to multiple persons',
  'electrical.mitigation.year.error': "Mitigation year {{mitigation}} can't be in the past",

  'common.duplicate.record.found': 'Duplicate {{columnLabel}} value {{value}}',
  'common.cell.dont.match.expected.value':
    "The value in excel on row: {{row}} cell: {{column}} doesn't match excepted value: {{expectedValue}}",
  'common.empty.rows':
    'There are some empty rows in file. Check for example row number: {{emptyRows}}',
  'common.is.not.number': '{{columnLabel}} {{number}} is not a number',
  'common.inspection.type.not.found': 'Inspection type is not correct',
  'common.field.is.empty': '{{columnLabel}} is empty',
  'common.intervention.date.do.not.match.inspection.summary':
    'Intervention date does not match intervention date in the inspection summary',
  'common.date.in.past': '{{columnLabel}} is more than {{pastMonthLimit}} month in the past',
  'common.date.in.future': '{{columnLabel}} is in the future',
  'common.error.parsing.date':
    '{{columnLabel}} is not formatted as a date. The permitted formats are: {{allowedDateFormats}}',
  'common.verification.report.number.not.consistent':
    'Report name {{reportName}} is not consistent for the verification report number {{verificationNumber}}',
  'common.verification.report.number.sent.for.validation':
    'Observation with {{verificationNumber}} verification report number is already being validated.',
  'common.error.observation.number.sequence':
    'Observation number field should be {{nextSequenceNumber}}',
  'common.report.was.not.uploaded': 'Report {{fileName}} was not uploaded',
  'common.inspector.not.found': 'Inspector {{inspector}} does not exist in the database',
  'common.inspector.ambiguous':
    'Ambiguous inspector name: {{inspector}} refers to multiple persons',
  'common.company.not.found': '{{company}} company not found',
  'common.company.doesnt.match.current.user':
    'Company name does not match with the company of the contractor who uploaded this document',
  'common.summary.file.has.errors': '{{fileType}} has errors. Please open for more details',

  'error.upload.not.found': 'Upload {{uploadId}} not found!',
  'success.upload.status.change': 'Successfully updated the status to «{{uploadStatus}}»',
  'error.upload.status.change': 'Error updating the status to «{{uploadStatus}}»!',
  'error.downloading.file': 'Error downloading file!',
  'success.upload.delete': 'Successfully deleted upload «{{uploadName}}»',
  'error.upload.delete': 'Error deleting upload «{{uploadName}}»!',
  'error.object.details.fetch': 'Error fetching object details!',
  'error.fetching.comments': 'Error fetching comments!',
  'error.saving.comment': 'Error saving comment!',
  'success.saving.comment': 'Comment was saved',
  'error.inspection.details.fetch': 'Error fetching inspection details {{inspectionId}}»!',

  '401.error.title': '403 Forbidden or 401 Unauthorized',
  '401.error.description':
    'You are forbidden or unauthorized to view this content. In order to request authorization, please contact software support.',

  'electrical.column.num.infrastructure': 'Acronym',
  'electrical.column.verification.number': 'Verification number',
  'electrical.column.intervention.date': 'Intervention date',
  'electrical.column.observation.number': 'Observation number',
  'electrical.column.floor': 'Floor',
  'electrical.column.local': 'Local',
  'electrical.column.outside': 'Is outside building',
  'electrical.column.equipment': 'Equipment',
  'electrical.column.equipment.number': 'Equipment number',
  'electrical.column.observation': 'Observation',
  'electrical.column.recommendation': 'Recommendation',
  'electrical.column.regulatory.ref': 'Regulatory reference',
  'electrical.column.cern.rule': 'CERN rule',
  'electrical.column.date.first.finding': 'Date of first finding',
  'electrical.column.criteria': 'Criteria',
  'electrical.column.priority': 'Priority',
  'electrical.column.acronym': 'Acronym',
  'electrical.column.file': 'File',
  'electrical.column.inspection.type': 'Inspection type',
  'electrical.column.executed.by': 'Executed by',
  'electrical.column.company': 'Company',
  'electrical.column.inspector': 'CERN Inspector',
  'electrical.column.comment': 'Comment',
  'electrical.column.disposition': 'Disposition',
  'electrical.column.conclusion': 'Conclusion',
  'electrical.column.mitigation': 'Mitigation',

  'lifting.column.equipment.code': 'Equipment code',
  'lifting.column.description': 'Description',
  'lifting.column.building': 'Building',
  'lifting.column.floor': 'Floor',
  'lifting.column.local': 'Local',
  'lifting.column.intervention.date': 'Intervention date',
  'lifting.column.verification.number': 'Verification report number',
  'lifting.column.conclusion': 'Conclusion',
  'lifting.column.observation.number': 'Observation number',
  'lifting.column.theme': 'Theme',
  'lifting.column.observation': 'Observation',
  'lifting.column.file': 'File',
  'lifting.column.capacity': 'Capacity',
  'lifting.column.inspection.type': 'Inspection type',
  'lifting.column.executed.by': 'Executed by',
  'lifting.column.company': 'Company',
  'lifting.column.inspector': 'CERN Inspector',
  'lifting.column.disposition': 'Disposition',
  'lifting.column.recommendation': 'Recommendation',
  'lifting.column.additional.conclusion': 'Additional conclusion',
};

export default TRANSLATIONS_EN;
